var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 center-xy"},[_c('img',{staticClass:"icon mb-5",attrs:{"src":require("@/assets/images/branding/logo_dark.svg")}}),_c('b-button',{staticClass:"btn-outline",attrs:{"id":"btnGoToLogin","to":{name: 'Login'}}},[_vm._v("ARTIST LOGIN")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b37fc88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Home.vue
// module id = null
// module chunks = 